<template>
    <div class="contentFormCreateTicket">
        <h3>Création de tickets support</h3>
            <el-form ref="form" :model="form" label-width="240px">
                <el-form-item label="Client" required>
                    <el-select class="inline-input" v-model="form.selectedSite" filterable remote reserve-keyword placeholder="Choisir un client" :remote-method="remoteSite" :loading="loadingSite" v-on:change="handleSelectSite">
                        <el-option v-for="item in tiers" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Contact" required>
                    <el-select v-if="form.selectedSite != ''" class="inline-input" v-model="form.selectedContact" filterable placeholder="Choisir un contact" v-on:change="handleSelectContact">
                        <el-option v-for="item in contacts" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        <el-option label="Nouveau contact" value="0"></el-option>
                    </el-select>
                    <el-select v-else disabled class="inline-input" placeholder="Choisir un contact">
                    </el-select>
                </el-form-item>
                <el-form-item v-if="form.selectedContact == '0'" label="Nom" required>
                    <el-input v-model="form.nomContact"></el-input>
                </el-form-item>
                <el-form-item v-if="form.selectedContact == '0'" label="Prénom" required>
                    <el-input v-model="form.prenomContact"></el-input>
                </el-form-item>
                <el-form-item v-if="form.selectedContact == '0'" label="Adresse mail">
                    <el-input v-model="form.mailContact"></el-input>
                </el-form-item>
                <el-form-item v-if="form.selectedContact == '0'" label="Téléphone">
                    <el-input v-model="form.telephoneContact"></el-input>
                </el-form-item>
                <el-form-item label="Type de demande" required>
                    <el-radio-group v-model="form.selectedType">
                        <el-radio label="COM">Question commerciale</el-radio>
                        <el-radio label="ISSUE">Incident</el-radio>
                        <el-radio label="OTHER">Autre</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Sujet" required>
                    <el-input v-model="form.sujet"></el-input>
                </el-form-item>
                <el-form-item label="Message" required>
                    <el-input type="textarea" rows="5" resize="none" v-model="form.messageTicket"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="createTicketAdmin()">Créer</el-button>
                    <el-button @click="initValue">Annuler</el-button>
                </el-form-item>
            </el-form>
        </div>
</template>

<script>
import script from '../../../script/script_ticketSup.js'
import scriptCds from '../../../script/script_cds'
function initValue(){
    return {
        form:{
            selectedType:'ISSUE',
            selectedSite:"",
            selectedContact:"",
            messageTicket:"",
            sujet:"",
            nomContact:"",
            prenomContact:"",
            mailContact:"",
            telephoneContact:""
        },
        optionsTypeCreate:[
            {value:'COM',text:"Question commerciale"},
            {value:'ISSUE',text:"Incident"},
            {value:'OTHER',text:"Autre"}
        ],
        tiers:[],
        contacts:[],
        loadingSite: false,
    }
}
export default {
    data () {
        return initValue()
    },
    props: {
    },
    methods: {
        verifyRight: script.verifyRight,
        searchTiers: scriptCds.searchTiers,
        sendTicketAdmin: script.sendTicketAdmin,
        searchContact: script.searchContact,
        async initialLoad(){
            this.verifyRight()
        },
        remoteSite(queryString) {
			if (queryString !== '') {
				this.loadingSite = true;
				setTimeout(() => {
					this.searchTiers(queryString)
					this.loadingSite = false;
				}, 200);
			} else {
				this.tiers = [];
			}
		},
        async handleSelectSite(){
            let result = await this.searchContact(this.form.selectedSite)
            if(result.length){
                result.forEach(element => {
                    this.contacts.push({label: element.lastname + " " + element.firstname, value: element.id})
                })
            }
        },
        async createTicketAdmin(){
            if(this.form.selectedContact == '0'){

            }else{
                
            }
            await this.sendTicketAdmin()
            initValue()
        }
    },
    created () {
    },
    mounted:async function(){
        this.initialLoad()
    },

}
</script>

<style>
.contentFormCreateTicket{
    width: 50%;
    margin: auto;
}
</style>